import { combineReducers } from "@reduxjs/toolkit";
import usageInfoReducer from "./slice/usageInfoSlice";

export const rootReducer = combineReducers({
  usageInfo: usageInfoReducer,
});
